export const ITEM_TYPE = {
  MOVIES: 'movies',
  TV: 'tv',
  CAST: 'cast'
} ;